<template>
  <el-dialog
    :title="title"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    width="460px"
    top="20vh"
    append-to-body
    class="small-padding"
    @close="onDialogClose">
    <div v-loading="contentLoading" class="body">
      <el-form ref="formValidate" class="form" :model="verifyCode" :rules="ruleValidate">
        <el-form-item prop="phone">
          <el-input v-model="verifyCode.phone" placeholder="请输入" disabled>
            <template slot="prepend">手机号</template>
          </el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input v-model="verifyCode.code" placeholder="请输入" style="width: 280px">
            <template slot="prepend">验证码</template>
          </el-input>
          <el-button
            type="success"

            :disabled="sendMsgBtnDisabled"
            :loading="sendMsgBtnLoading"
            @click="sendMsg">
            {{sendMsgBtnText}}
          </el-button>
        </el-form-item>
        <el-button type="primary" style="width: 100%" @click="handleSubmit()">提交</el-button>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        countdownSeconds: 60,
        sendMsgBtnDisabled: false,
        sendMsgBtnText: "发送短信",
        sendMsgBtnLoading: false,
        elevatorId: 0,
        verifyCode: {
          phone: "",
          code: "",
        },
        ruleValidate: {
          code: {required: true, message: "验证码不能为空", trigger: "blur"},
        },
      };
    },
    computed: {
      title() {
        return this.$t("获取验证码");
      },
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.getData();
      },
      getData() {
        this.$api.getData("account").then(res => {
          let data = res.data;
          this.verifyCode.phone = data.phone;
          this.contentLoading = false;
        }).catch((error) => {
          this.contentLoading = false;
          if (error.response) {
            this.$message.error(this.$t("common.tip.getDataError") + error.response.data.message);
          }
        });
      },
      countdown() {
        if (this.countdownSeconds === 0) {
          this.sendMsgBtnDisabled = false;
          this.sendMsgBtnText = "发送短信";
          this.countdownSeconds = 60;
        } else {
          this.sendMsgBtnDisabled = true;
          this.sendMsgBtnText = "重新发送" + this.countdownSeconds + "s";
          this.countdownSeconds--;
          setTimeout(() => {
            this.countdown();
          }, 1000);
        }
      },
      sendMsg() {
        this.$api.getData("remote/escalatorControl/sendMsg").then((res) => {
          this.countdown();
          this.$message.success("短信发送成功,10分钟内有效");
          this.sendMsgBtnLoading = false;
        }).catch(error => {
          this.sendMsgBtnLoading = false;
          if (error.response) {
            this.$message.error("短信发送失败," + error.response.data.message);
          }
        });
      },
      handleSubmit() {
        this.ruleValidate.code.required = true;
        this.$refs.formValidate.validate((valid) => {
          if (valid) {
            let params = {
              phone: this.verifyCode.phone,
              code: this.verifyCode.code,
            };
            this.$api.getData("remote/escalatorControl/checkCode", params).then((res) => {
              this.$emit("select", this.verifyCode.code);
              this.dialogVisible = false;
            }).catch(error => {
              if (error.response.data.code === 1) {
                this.$message.error("验证码不正确或者已过期");
              }
            });
          }
        });
      },
      onDialogClose() {
        this.contentLoading = false;
        this.$refs.formValidate.resetFields();
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
